// client/src/store.js
import { configureStore } from "@reduxjs/toolkit";

export const store = configureStore({
    reducer: {
        // your reducers
    },
});